import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _bulkUpdateTicketsRequest = {};
var _bulkUpdateTicketsResponse = { tickets: '_ticketingTicket' };
var _checkIn = { created: 'google.protobuf.Timestamp' };
var _checkInTicketRequest = {};
var _checkInTicketResponse = { tickets: '_ticketingTicket' };
var _deleteTicketCheckInRequest = {};
var _deleteTicketCheckInResponse = { tickets: '_ticketingTicket' };
var _formattedAddress = { address: '_address' };
var _formResponse = { inputValues: '_inputValue' };
var _getTicketRequest = {};
var _getTicketResponse = { ticket: '_ticketingTicket' };
var _guestDetails = { form: '_formResponse' };
var _guestDetailsUpdate = { form: '_formResponse' };
var _inputValue = {
    number: 'google.protobuf.DoubleValue',
    dateTime: 'google.protobuf.Timestamp',
    address: '_formattedAddress',
};
var _listTicketsRequest = {};
var _listTicketsResponse = { tickets: '_ticketingTicket' };
var _ticketingTicket = { checkIn: '_checkIn', guestDetails: '_guestDetails' };
var _updateTicketRequest = {
    fields: 'google.protobuf.FieldMask',
    checkoutForm: '_formResponse',
    guestDetails: '_guestDetailsUpdate',
};
var _updateTicketResponse = { ticket: '_ticketingTicket' };
function resolveWixEventsTicketingTicketManagementUrl(opts) {
    var domainToMappings = {
        'events._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
        ],
        'www.wixevents.com': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/api',
                destPath: '/api',
            },
            {
                srcPath: '/viewEvent',
                destPath: '/viewEvent',
            },
            {
                srcPath: '/viewRsvpDashboard',
                destPath: '/viewRsvpDashboard',
            },
            {
                srcPath: '/viewOrderDashboard',
                destPath: '/viewOrderDashboard',
            },
            {
                srcPath: '/viewSummarySubscription',
                destPath: '/viewSummarySubscription',
            },
            {
                srcPath: '/check-in',
                destPath: '/check-in',
            },
            {
                srcPath: '/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/export',
                destPath: '/export',
            },
            {
                srcPath: '/tickets',
                destPath: '/tickets',
            },
            {
                srcPath: '/payment-redirect',
                destPath: '/payment-redirect',
            },
            {
                srcPath: '/admin',
                destPath: '/admin',
            },
            {
                srcPath: '/ticket',
                destPath: '/ticket',
            },
            {
                srcPath: '/media',
                destPath: '/media',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-events-web',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/events/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/events/v2',
                destPath: '/v2',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/events/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/events/v1/reports',
                destPath: '/v1/reports',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/site',
                destPath: '/v1/site',
            },
            {
                srcPath: '/events/v1/web',
                destPath: '/v1/web',
            },
            {
                srcPath: '/events/v2/tickets',
                destPath: '/v2/tickets',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a list of up to 100 tickets, given the provided [pagination](https://dev.wix.com/api/rest/getting-started/pagination), [filtering & sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-tickets). */
export function listTickets(payload) {
    var _a = serializer(_listTicketsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTicketsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __listTickets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket',
            method: 'GET',
            methodFqn: 'wix.events.ticketing.TicketManagement.ListTickets',
            url: resolveWixEventsTicketingTicketManagementUrl({
                protoPath: '/v1/events/{eventId}/tickets',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixEventsTicketingTicketManagementUrl({
                        protoPath: '/v1/events/{eventId}/tickets',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __listTickets.fromReq = fromReq;
    __listTickets.__isAmbassador = true;
    return __listTickets;
}
/** Retrieves a ticket by unique ticket number. */
export function getTicket(payload) {
    var _a = serializer(_getTicketRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTicketResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __getTicket(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket',
            method: 'GET',
            methodFqn: 'wix.events.ticketing.TicketManagement.GetTicket',
            url: resolveWixEventsTicketingTicketManagementUrl({
                protoPath: '/v1/events/{eventId}/tickets/{ticketNumber}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTicket.fromReq = fromReq;
    __getTicket.__isAmbassador = true;
    return __getTicket;
}
/** Checks in 1 or more tickets. */
export function checkInTicket(payload) {
    var _a = serializer(_checkInTicketRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_checkInTicketResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __checkInTicket(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.TicketManagement.CheckInTicket',
            url: resolveWixEventsTicketingTicketManagementUrl({
                protoPath: '/v1/tickets/check-in',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __checkInTicket.fromReq = fromReq;
    __checkInTicket.__isAmbassador = true;
    return __checkInTicket;
}
/** Deletes check-ins for 1 or more tickets. */
export function deleteTicketCheckIn(payload) {
    var _a = serializer(_deleteTicketCheckInRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteTicketCheckInResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __deleteTicketCheckIn(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket',
            method: 'DELETE',
            methodFqn: 'wix.events.ticketing.TicketManagement.DeleteTicketCheckIn',
            url: resolveWixEventsTicketingTicketManagementUrl({
                protoPath: '/v1/tickets/check-in',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteTicketCheckIn.fromReq = fromReq;
    __deleteTicketCheckIn.__isAmbassador = true;
    return __deleteTicketCheckIn;
}
/** Updates a ticket. See [Partial Updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information. */
export function updateTicket(payload) {
    var _a = serializer(_updateTicketRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetailsUpdate: _guestDetailsUpdate,
        _inputValue: _inputValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTicketResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __updateTicket(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketing.TicketManagement.UpdateTicket',
            url: resolveWixEventsTicketingTicketManagementUrl({
                protoPath: '/v1/events/{eventId}/tickets/{ticketNumber}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTicket.fromReq = fromReq;
    __updateTicket.__isAmbassador = true;
    return __updateTicket;
}
/** Updates the `archived` state of multiple tickets. See [Partial Updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information. */
export function bulkUpdateTickets(payload) {
    var _a = serializer(_bulkUpdateTicketsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateTicketsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __bulkUpdateTickets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketing.TicketManagement.BulkUpdateTickets',
            url: resolveWixEventsTicketingTicketManagementUrl({
                protoPath: '/v1/events/{eventId}/tickets',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateTickets.fromReq = fromReq;
    __bulkUpdateTickets.__isAmbassador = true;
    return __bulkUpdateTickets;
}
//# sourceMappingURL=http.impl.js.map